/**
 * @module
 * @import {InternalEngine} from '@acng/frontend-stargazer';
 */

export {CLICK_POPUP};

import {AttributeLink, AttributeSetup, Engine, getConfig, getNodes, resolve} from '@acng/frontend-stargazer';
import {close, open} from '@acng/frontend-relativity';
import {popup} from '@acng/frontend-discovery';
import {create, DIV} from '@acng/frontend-bounty/dom/element.js';
import {guard, IS, OPTIONAL, STRING, TUPLE} from '@acng/frontend-rubicon';

import {onClick} from '../service/worker.js';
import {enter, leave} from '../service/animate-class.js';
import {replaceAll} from '@acng/frontend-bounty/dom/move.js';

/**
 * @group DOM Attribute
 */
const CLICK_POPUP = 'click-popup';

AttributeSetup(CLICK_POPUP, (name) => {

  AttributeLink(name, (element, value) => {
    const div = create(DIV);

    return (element, engine) =>
      onClick(element, async (element) => {
        const controller = popup(element);
        const linker = await getEngine(engine, value);
        if (controller.isOpen(div)) {
          return;
        }

        open(element, div);
        linker.toElement(div, getConfig(engine));
        controller.add(div, 0, async (element) => enter(element), async (element) => {
          await leave(element);
          replaceAll(div);
        })
          .finally(() => {
            linker.disconnect();
            close(element, div);
          });
      });
  });
});

  const syntax = /^(#)?(.*)$/;

  /**
   * @param {InternalEngine} engine
   * @param {string} value
   * @returns {Promise<Engine>}
   */
  export const getEngine = async (engine, value) => {
    const match = syntax.exec(value);
    ASSERT: guard(match, TUPLE(STRING, OPTIONAL(STRING), STRING), `[$name] syntax`);
    const [, isLocal, alias] = match;

    if (isLocal) {
      const {[alias]: template} = getNodes(engine);
      ASSERT: guard(template, IS(HTMLTemplateElement));
      const linker = new Engine(template);
      await linker.lookup();

      return linker;
    } else {
      return Engine.root.render(...resolve(alias));
    }
  };
